import { Helmet } from 'react-helmet'
import Announcement from '../components/Announcement'
import Navbar from '../components/Navbar'
import Developers from '../components/Developers'
import Footer from '../components/Footer'
import ScrollToTop from '../components/ScrollToTop'

function DevelopersPage() {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Whistle Pulse API Documentation</title>
        <link rel="canonical" href="https://whistlepulse.com/developers" />
        <meta
          name="description"
          content="Interactive Whistle Pulse API documentation for single SMS, bulk SMS, personalized SMS, callbacks, and OTP integrations."
        />
      </Helmet>

      <Announcement />
      <Navbar />
      <Developers />
      <Footer />
      <ScrollToTop />
    </div>
  )
}

export default DevelopersPage
